var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "48.167px",
    viewBox: "0 0 50 48.167",
    enableBackground: "new 0 0 50 48.167",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Back") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.081,35.479c-1.519,1.517-1.519,3.978,0,5.495c1.521,1.517,3.984,1.517,5.503,0c1.52-1.518,1.52-3.979,0-5.495 C14.065,33.959,11.602,33.959,10.081,35.479z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.766,25.099c0-2.413-1.959-4.373-4.376-4.373c-2.417,0-4.377,1.96-4.377,4.373c0,2.414,1.96,4.372,4.377,4.372 C9.806,29.471,11.766,27.514,11.766,25.099z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.832,7.114c-2.686,0-4.862,2.175-4.862,4.859c0,2.682,2.177,4.856,4.862,4.856c2.687,0,4.862-2.174,4.862-4.856 C17.694,9.289,15.519,7.114,12.832,7.114z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.973,1.177c-2.955,0-5.35,2.394-5.35,5.344s2.395,5.344,5.35,5.344c2.955,0,5.349-2.394,5.349-5.344 C31.322,3.571,28.928,1.177,25.973,1.177z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.973,39.221c-1.88,0-3.403,1.522-3.403,3.402c0,1.876,1.523,3.399,3.403,3.399c1.879,0,3.404-1.523,3.404-3.399 C29.377,40.744,27.852,39.221,25.973,39.221z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.554,22.669c-1.342,0-2.43,1.087-2.43,2.43c0,1.342,1.088,2.429,2.43,2.429c1.344,0,2.433-1.087,2.433-2.429 C46.986,23.756,45.897,22.669,44.554,22.669z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.049,36.165c-1.139,1.138-1.139,2.984,0,4.123c1.14,1.139,2.985,1.139,4.127,0c1.139-1.139,1.139-2.985,0-4.123 C40.034,35.026,38.188,35.026,37.049,36.165z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.298,13.729c1.076,0,1.946-0.869,1.946-1.943c0-1.073-0.87-1.944-1.946-1.942c-1.072,0-1.945,0.87-1.944,1.942 C37.354,12.859,38.226,13.729,39.298,13.729z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.7e77ea88.svg";
export { ForwardRef as ReactComponent };